import React from "react";

function Footer() {
  return (
    <div className="mt-8 bg-[#009FE3]">
      <div className="app-container py-8 text-center text-white">
        <p className="text-[1rem]">Copyright &copy; Phillips Akindele and Co 2023</p>
      </div>
    </div>
  );
}

export default Footer;
